
// src/api/axios.js
import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL||"https://iplboneva.jagsonpal.in/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
});

export default api;
